
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
}

:host([border="full"]){
  border-width:1px !important;
  border-style:solid !important;
}

:host([border="top"]){
  border-style:solid !important;
  border-top-width:1px !important;
}

:host([border="bottom"]){
  border-style:solid !important;
  border-bottom-width:1px !important;
}

:host([border-color="black"]) {
  border-color: var(--neutral-black);
}

:host([border-color="white"]) {
  border-color: var(--neutral-white);
}

:host([border-color="blue"]) {
  border-color: var(--blue-responsible-main);
}

:host([border-color="blue-dark"]) {
  border-color: var(--blue-responsible-darken-2);
}

:host([border-color="gray"]){
  border-color:var(--neutral-grayMedium) !important;
}

:host([margin-size='0px']) p {
  margin: 0px;
}

:host([margin-size='4px']) p {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

:host([margin-size='8px']) p {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

:host([margin-size='12px']) p {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

:host([margin-size='20px']) p {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

:host([margin-size='24px']) p {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

:host([margin-size='31px']) p {
  margin-top: 31px;
  margin-bottom: 31px;
}

:host([margin-size='56px']) p {
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
}

.idb-heading__wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.idb-heading__cta {
  align-self: center;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-weight: var(--fw-normal);
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
  color:inherit;
}

.idb-heading__title {
  text-align: left;
}

@media (min-width: 480px) {

  .idb-heading__title.idb-short-title {
    max-width: 80%;
  }
}

@media (min-width: 640px) {

  .idb-heading__title.idb-short-title {
    max-width: 60%;
  }
}

@media (min-width: 768px) {

  .idb-heading__title.idb-short-title {
    max-width: 50%;
  }
}

@media (min-width: 1024px) {

  .idb-heading__title.idb-short-title {
    max-width: 44%;
  }
}

@media (min-width: 1280px) {

  .idb-heading__title.idb-short-title {
    max-width: 31%;
  }
}

@media (min-width: 2180px) {

  .idb-heading__title.idb-short-title {
    max-width: 20%;
  }
}

idb-button {
  align-self: center;
}

.idb-heading__wrapper:has(.idb-heading__cta-list) {
  flex-direction: column;
  justify-content: center;
  gap: 0.75rem;
}

@media (min-width: 1024px) {

  .idb-heading__wrapper:has(.idb-heading__cta-list) {
    flex-direction: row;
  }

  .idb-heading__wrapper:has(.idb-heading__cta-list) {
    justify-content: flex-start;
  }
}

.idb-heading__title.idb-margin-xs {
  margin-bottom: 0px;
}

@media (min-width: 1024px) {

  .idb-heading__title.idb-margin-xs {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}

.idb-heading__cta-list {
  margin-left: 0px;
  margin-top: 0px;
  display: flex;
  list-style-type: none;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  gap: 0.5rem;
  padding-left: 0px;
}

@media (min-width: 640px) {

  .idb-heading__cta-list {
    flex-direction: row;
  }
}

@media (min-width: 1024px) {

  .idb-heading__cta-list {
    margin: 0px;
  }

  .idb-heading__cta-list {
    align-items: center;
  }
}

.idb-heading__cta-list.idb-heading__cta--align-left {
  margin-right: auto;
}

@media (min-width: 1024px) {

  .idb-heading__cta-list.idb-heading__cta--align-left {
    justify-content: flex-start;
  }
}

.idb-heading__cta-list.idb-heading__cta--align-center {
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 1024px) {

  .idb-heading__cta-list.idb-heading__cta--align-center {
    justify-content: center;
  }
}

.idb-heading__cta-list.idb-heading__cta--align-right {
  margin-left: auto;
}

@media (min-width: 1024px) {

  .idb-heading__cta-list.idb-heading__cta--align-right {
    justify-content: space-between;
  }
}

.idb-heading__cta-listli {
  margin: 0px;
}

.idb-heading__cta-listli {
  list-style-type: none;
}
`;